import { render, staticRenderFns } from "./ModalWhyEmail.vue?vue&type=template&id=be53b1ac"
import script from "./ModalWhyEmail.vue?vue&type=script&lang=js"
export * from "./ModalWhyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports